export default __webpack_public_path__ + "static/media/FORD.fe379bbf.png";